<nav class="navbar shadow-sm justify-content-center justify-content-lg-start" [ngClass]="domain">
  <div class="navbar-brand m-0">
    <img [src]="logoSRC" alt="SelfID Logo">
  </div>
</nav>
